module.exports = __webpack_public_path__ + "media/St 4-refrigerator-incorrect.86211a51.wav";